export default __webpack_public_path__ + "static/media/Pill 3.b6231e93.png";